import Image from 'next/image';
import React from 'react';
type Props = {
    text: string;
    path: any;
    alt: string;
    width: number;
    height: number;
    className?: string;
};
const TaxiAppCloneCostCard: React.FC<Props> = ({ text, path, alt, width, height }) => {
    return (
        <div
            className="card p-30 bg-white dark:bg-black rounded-10 border text-center"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="300"
        >
            <div className="card-body">
                <Image src={path} className="img-fluid" alt={alt} title={alt} width={width} height={height} />
                <p className="card-text fw-700 mt-3.5">{text}</p>
            </div>
        </div>
    );
};

export default TaxiAppCloneCostCard;
